import i18n from 'config/i18n';
import { ipAddressessSchema } from 'constants/schemas';
import * as Yup from 'yup';
import IpFormatSelect from '../../components/select/IpFormatSelect';
import IpVersionSelect from '../../components/select/IpVersionSelect';
import { InputField } from '../../types';
import { CUSTOM, GENERAL_DATA } from '../index';
import { IpRangeFormat, IpVersion } from '../../../app/types';

const ipVersionFields: InputField[] = [
  {
    addLabel: 'Add IP range',
    fields: [
      {
        component: IpFormatSelect,
        label: 'ipVersion.formLabels.format',
        name: 'format',
        type: CUSTOM,
        width: {
          desktop: 6,
        },
      },
      {
        component: IpVersionSelect,
        label: 'ipVersion.formLabels.ipVersion',
        name: 'ipVersion',
        type: CUSTOM,
        width: {
          desktop: 6,
        },
      },
      {
        label: 'ipVersion.formLabels.ipAddresses',
        name: 'ipAddresses',
        type: 'text',
        width: {
          desktop: 6,
        },
      },
      {
        label: 'ipVersion.formLabels.description',
        name: 'description',
        type: 'text',
        width: {
          desktop: 6,
        },
      },
    ],
    initialValue: null,
    name: 'generalIpRanges',
    removeLabel: 'Remove IP range',
    type: 'array',
    width: {
      desktop: 12,
    },
  },
];

const ipRangeItemSchema = Yup.object().shape({
  description: Yup.string().required(() => i18n.t('validation:required')),
  format: Yup.mixed()
    .required(() => i18n.t('validation:required'))
    .oneOf([...Object.values(IpRangeFormat)], ({ values }) => i18n.t('validation:oneOf', { values })),
  ipAddresses: ipAddressessSchema,
  ipVersion: Yup.mixed()
    .oneOf([IpVersion.Ipv4, IpVersion.Ipv6], ({ values }) => i18n.t('validation:oneOf', { values }))
    .required(() => i18n.t('validation:required'))
    .nullable(),
});

const ipVersionValidationSchema = Yup.object().shape({
  generalIpRanges: Yup.array()
    .of(ipRangeItemSchema)
    .when('mispToMisp', {
      is: 'true',
      then: Yup.array()
        .of(ipRangeItemSchema)
        .required()
        .min(1, ({ min }) => i18n.t('validation:array.min', { min })),
    }),
});

const headerTranslations = {
  content: 'generalIpVersion.content',
  title: 'generalIpVersion.title',
};

export const generalIpVersions = {
  fields: ipVersionFields,
  headerTranslations,
  key: 'ipRanges',
  submitParam: GENERAL_DATA,
  validationSchema: ipVersionValidationSchema,
};
